const toHyphenatedString = ({ str }: { str: unknown }) => {
  if (typeof str !== 'string') return '';

  return str.toLowerCase().replace(/\s/g, '-');
};

export default toHyphenatedString;
